import LinkRouter from "../navigation/LinkRouter";
import TileSection from "./TileSection";
import {
  BookOpenCheck,
  HeartHandshake,
  MessageCircleQuestion,
  MessageSquare,
  Copy,
} from "lucide-react";
import { useContext } from "react";
import Panel, { CommonTileProps } from "./Panel";
import { Alert, AlertTitle, Box, Button } from "@mui/material";
import { StatusContext } from "../context/StatusContextProvider";
import { CurrentUserContext } from "../context/RequireAuth";
import { userReferralLink } from "../referrals/utils";
import { useSnackpack } from "../context/SnackpackContextProvider";
import { shouldShowClientOpportunitiesAlert } from "./ClientOpportunitiesAlert";
import ClientOpportunitiesAlert from "./ClientOpportunitiesAlert";

const HealthAlert = () => (
  <Alert severity="error" sx={{ margin: "16px 0", backgroundColor: "#FDEDED" }}>
    <AlertTitle>One or more families need attention</AlertTitle>
    Please check your{" "}
    <LinkRouter inline={true} to="/families">
      dashboard
    </LinkRouter>{" "}
    for more information.
  </Alert>
);

export default () => {
  const {
    familyHealthAlert,
    newClientOpportunitiesToggledSec,
    newClientOpportunitiesEnabled,
  } = useContext(StatusContext);
  const currentUser = useContext(CurrentUserContext);
  const { pushSnack } = useSnackpack();
  const referralLink = userReferralLink(currentUser.ref, true);
  const displayLink = referralLink.replace(/^https?:\/\//, "");

  const handleCopy = async () => {
    await navigator.clipboard.writeText(referralLink);
    pushSnack("Copied to clipboard!");
  };

  const showAlert = shouldShowClientOpportunitiesAlert(
    newClientOpportunitiesToggledSec,
  );

  return (
    <>
      {showAlert && (
        <ClientOpportunitiesAlert
          advisorRef={currentUser.ref}
          currentValue={newClientOpportunitiesEnabled}
        />
      )}
      {familyHealthAlert && <HealthAlert />}
      {
        <Panel
          title="Make more money with referrals!"
          content={
            <Box>
              Share your unique affiliate code with friends, family, and
              colleagues. They get 15% off any Faye plan, and you earn 15% of
              their first month's payment. It's an easy way to build passive
              income while helping fellow Advisors grow their businesses.
              <Button
                variant="text"
                onClick={handleCopy}
                startIcon={<Copy size={16} />}
                sx={{
                  height: "unset",
                  ".MuiButton-icon": {
                    marginRight: "4px",
                    marginLeft: "6px",
                  },
                }}
              >
                {displayLink}
              </Button>
            </Box>
          }
        />
      }
      <TileSection
        tiles={[
          {
            title: "Ask FAs",
            icon: <MessageCircleQuestion {...CommonTileProps} />,
            path: "/community/ask-fas",
          },
          {
            title: "Recommendations",
            icon: <HeartHandshake {...CommonTileProps} />,
            path: "/community/recommendations",
          },
          {
            title: "Resources",
            icon: <BookOpenCheck {...CommonTileProps} />,
            path: "/community/resources",
          },
          {
            title: "Chatter",
            icon: <MessageSquare {...CommonTileProps} />,
            path: "/community/chatter",
          },
        ]}
      />
    </>
  );
};
